import { ApiService, type ApiRequestConfig } from "./api.service";
import type { TProjectBulkInviteFormData, TProjectInvitation } from "@/types/project";

export class ProjectInvitationService extends ApiService {
  async list(
    slug: string,
    projectId: string,
    config?: ApiRequestConfig,
  ): Promise<TProjectInvitation[]> {
    // Server-paginated (issue #1254); walk the pages so the project invitations
    // panel keeps the full set it renders locally. UI is unchanged.
    return this.getAllPages<TProjectInvitation>(
      ({ cursor, perPage }) => {
        const qs = new URLSearchParams({ per_page: String(perPage) });
        if (cursor) qs.set("cursor", cursor);
        return `/api/workspaces/${slug}/projects/${projectId}/invitations/?${qs}`;
      },
      undefined,
      config,
    );
  }

  async invite(
    slug: string,
    projectId: string,
    data: TProjectBulkInviteFormData,
  ): Promise<TProjectInvitation[]> {
    return this.post(`/api/workspaces/${slug}/projects/${projectId}/invitations/`, data);
  }

  async revoke(slug: string, projectId: string, invitationId: string): Promise<void> {
    return this.delete(
      `/api/workspaces/${slug}/projects/${projectId}/invitations/${invitationId}/`,
    );
  }
}
